import {
  ItemSetSubQuestionEditFormActions,
  ItemSetSubQuestionPublishValidator,
  SubQuestionPreviewButton,
  useQContentDetailsModal,
} from '@exam-management/qcontent-detail';
import {
  GoToParagraphLink,
  LocationSectionWrapper,
  QuestionLayout,
  ItemSetLocationsPreview,
  ItemSetSubQuestionDetails,
} from '@exam-management/qcontent-management';
import { useParams } from '@exam-management/router';
import { Flex, PaperSection } from '@shared/components';

export default function ItemSetSubQuestionDetailPage() {
  const { updatePUse } = useQContentDetailsModal();
  const { structureId, questionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId',
  );

  return (
    <>
      <QuestionLayout
        sideContent={
          <PaperSection title='Location'>
            <LocationSectionWrapper>
              <ItemSetLocationsPreview />
            </LocationSectionWrapper>
          </PaperSection>
        }
      >
        <Flex sx={{ width: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
          <PaperSection title='Question Details' endAdornment={<SubQuestionPreviewButton />}>
            <ItemSetSubQuestionDetails
              onClickUpdatePStat={updatePUse}
              informationTitleEndAdornment={
                <GoToParagraphLink
                  to='/qbank-structures/:structureId/qcontents/item-set/:questionId'
                  params={{ structureId, questionId }}
                />
              }
            />
          </PaperSection>
          <ItemSetSubQuestionEditFormActions />
        </Flex>
      </QuestionLayout>
      <ItemSetSubQuestionPublishValidator />
    </>
  );
}
